module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Bubikon-ec69e9f821adc279acc1369b593b5d57.svg";